package com.essntl.features.proposal.ui.addeditproposal.components

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.text.input.KeyboardType
import com.essntl.features.client.ui.ClientItem
import com.essntl.features.proposal.domain.model.ProposalModel
import com.essntl.features.proposal.ui.addeditproposal.AddEditProposalEvent
import com.essntl.features.proposal.ui.addeditproposal.AddEditProposalNavigation
import com.essntl.features.proposal.ui.addeditproposal.AddEditProposalState
import com.essntl.uikit.components.button.secondary.EsLargeSecondaryButton
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.components.input.EsInput
import com.essntl.uikit.components.utils.EsConstants
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.rememberEquals
import com.essntl.uikit.theme.esColorScheme

@OptIn(ExperimentalLayoutApi::class)
@Composable
fun ClientInformation(
    state: AddEditProposalState,
    onEvent: (AddEditProposalEvent) -> Unit,
    onNavigation: (AddEditProposalNavigation) -> Unit,
    proposal: ProposalModel,
) {
    Column(
        verticalArrangement = Arrangement.Center,
        horizontalAlignment = Alignment.Start,
        modifier = Modifier
            .fillMaxWidth()
            .clip(
                RoundedCornerShape(EsConstants.SectionBorderRadius),
            )
            .background(MaterialTheme.esColorScheme.bgSecondary)
            .padding(
                vertical = EsConstants.SectionVerticalPadding,
                horizontal = EsConstants.SectionHorizontalPadding,
            ),
    ) {
        Column(
            verticalArrangement = Arrangement.Center,
            horizontalAlignment = Alignment.Start,
            modifier = Modifier
                .fillMaxWidth(),
        ) {
            Row(
                verticalAlignment = Alignment.Top,
                horizontalArrangement = Arrangement.spacedBy(2.spacing),
                modifier = Modifier.fillMaxWidth(),
            ) {
                EsInput(
                    value = proposal.guestCount.let { if (it > 0) "$it" else "" },
                    placeholder = "Enter client count",
                    label = "Count",
                    enabled = state.isEnabled,
                    onValueChange = {
                        val guestCount = it.toIntOrNull() ?: 0

                        onEvent(
                            AddEditProposalEvent.UpdateProposalFields(
                                proposal.copy(
                                    guestCount = guestCount,
                                ),
                            ),
                        )
                    },
                    keyboardOptions = KeyboardOptions(
                        keyboardType = KeyboardType.Number,
                    ),
                    modifier = Modifier.fillMaxWidth(0.2f),
                )

                EsInput(
                    value = proposal.guestDetails ?: "",
                    placeholder = "Type in the description (e.g. 2 parents, 1 teenager)",
                    label = "Travellers description",
                    enabled = state.isEnabled,
                    singleLine = false,
                    onValueChange = {
                        onEvent(
                            AddEditProposalEvent.UpdateProposalFields(
                                proposal.copy(
                                    guestDetails = it,
                                ),
                            ),
                        )
                    },
                    keyboardOptions = KeyboardOptions(
                        keyboardType = KeyboardType.Number,
                    ),
                    modifier = Modifier.fillMaxWidth(),
                )
            }
            Spacer(modifier = Modifier.height(3.spacing))
            FlowRow(
                horizontalArrangement = Arrangement.spacedBy(1.5.spacing),
                verticalArrangement = Arrangement.spacedBy(1.spacing),
                modifier = Modifier
                    .fillMaxWidth(),
            ) {
                for (currentClient in state.getAllClient.data.orEmpty()) {
                    val isPrimaryClient = rememberEquals(proposal.primaryClient?.id, setOf(currentClient.id)) { it }

                    ClientItem(
                        client = currentClient,
                        isPrimaryClient = isPrimaryClient,
                        onSetClientPrimary = {
                            onEvent(
                                AddEditProposalEvent.UpdateProposalFields(
                                    proposal.copy(
                                        primaryClient = currentClient,
                                    ),
                                ),
                            )
                        },
                        onDeleteClient = {
                            onEvent(AddEditProposalEvent.DeleteClient(currentClient))
                        },
                        onEditClient = {
                            onNavigation(AddEditProposalNavigation.EditClient(currentClient))
                        },
                        enabled = state.isEnabled,
                    )
                }

                EsLargeSecondaryButton(
                    text = "Add existing",
                    prefixIconRes = EsIcons.Add,
                    enabled = state.isEnabled,
                    onClick = { onNavigation(AddEditProposalNavigation.SelectClient) },
                    modifier = Modifier.padding(top = 1.spacing),
                )

                EsLargeSecondaryButton(
                    text = "Add new",
                    prefixIconRes = EsIcons.Add,
                    enabled = state.isEnabled,
                    onClick = { onNavigation(AddEditProposalNavigation.AddClient) },
                    modifier = Modifier.padding(top = 1.spacing),
                )
            }
        }
    }
}